import './hero-banner/hero-banner';
import './textual-banner/textual-banner';
import './footer/footer';
import './project-lifecycle/project-lifecycle';
import './card-other-information/card-other-information';
import './breadcrumb/breadcrumb';
import './details-page/details-page';
import './button-call-to-action/button-call-to-action';
import './spending-progress/spending-progress';
import './latest-cards-tender-notice/latest-cards-tender-notice';
import './image-banner/image-banner';

import Title from './title/title';
import Header from './header/header';
import Accordion from './accordion/accordion';
import CarouselObjectives from './carousel-objectives/carousel-objectives';
import DoughnutCharts from './doughnut-chart/doughnut-chart';
import Gallery from './gallery/gallery';
import PieChartOverview from './pie-chart-overview/pie-chart-overview';
import FinancialAllocationsTable from './financial-allocations-table/financial-allocations-table';
import Video from './video/video';
import NewsCarousel from './news-carousel/news-carousel';
import MiniCarousel from './carousel-cards/mini-carousel';
import Faq from './faq/faq';
import ForegroundProjects from './foreground-projects/foreground-projects';
import Contacts from './contacts/contacts';
import VerticalBarChart from './vertical-bar-chart/vertical-bar-chart';
import HorizontalBarChart from './horizontal-bar-chart/horizontal-bar-chart';
import LineChart from './line-chart/line-chart';
import NewsCards from './news-cards/news-cards';
import TabCards from './tab-cards/tab-cards';
import Filters from './filters/filters';
import OrganizationChart from './organigram/organization-chart';
import Index from './index/index';
import Card from './@commons/card/card';
import Map from './map/map';
import SpecificObjectives from './specific-objectives/specific-objectives';
import AreaChart from './area-chart/area-chart';
import Attachments from './attachments/attachments';
import CardRest from './@commons/card/card-rest';
import CalendarComponent from './calendar/calendar';
import TextualBanner from './textual-banner/textual-banner';

export function Components() {
    Title();
    Header();
    Accordion();
    CarouselObjectives();
    DoughnutCharts();
    Gallery();
    PieChartOverview();
    FinancialAllocationsTable();
    Video();
    NewsCarousel();
    MiniCarousel();
    Faq();
    ForegroundProjects();
    Contacts();
    VerticalBarChart();
    HorizontalBarChart();
    LineChart();
    NewsCards();
    TabCards();
    Filters();
    OrganizationChart();
    SpecificObjectives();
    Index();
    Card();
    CardRest();
    Map();
    AreaChart();
    Attachments();
    CalendarComponent();
    TextualBanner();
}
